import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  makeStyles,
} from '@material-ui/core';
import { useAuthentication } from '@acclaim/udaf-kit';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: '2em',
    textAlign: 'center',
  },
  btn: {
    border: 'none',
    background: 'transparent',
    fontSize: 'inherit',
    color: theme.custom.blue,
    outline: 'none',
    padding: '0',
    margin: '0',
    cursor: 'pointer',
  },
}));

const LoginPlaceholder = ({ title }) => {
  const classes = useStyles();
  const { login, signup } = useAuthentication();

  return (
    <div className={classes.wrapper}>
      <Typography className={classes.nobrands}>
        <strong>{title}</strong>
        <br />
        <button className={classes.btn} onClick={login}>login</button>
        &nbsp;or&nbsp;
        <button className={classes.btn} onClick={signup}>create an account</button>
      </Typography>
    </div>
  );
};

LoginPlaceholder.propTypes = {
  title: PropTypes.string.isRequired,
};

export default LoginPlaceholder;
